module.exports = __webpack_public_path__ + "static/img/QYSJP-DPAWTr3b.2ebe5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/QYSJP-DPAWTr3b.png
// module id = RlXR
// module chunks = 16